var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAwardWinning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#27D6FF",
    fillRule: "evenodd",
    d: "M16.769 12.572l-4.523 1.211-3.01 3.16c-.339.357-.937.204-1.065-.271l-.449-1.676c-1.377.368-2.792-.448-3.16-1.825L3.088 7.673c-.368-1.377.449-2.792 1.825-3.16l9.047-2.425c1.377-.368 2.791.448 3.16 1.825l1.473 5.499c.37 1.376-.448 2.791-1.824 3.16z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#320B42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.211,
    d: "M16.769 12.572l-4.523 1.211-3.01 3.16c-.339.357-.937.204-1.065-.271l-.449-1.676c-1.377.368-2.792-.448-3.16-1.825L3.088 7.673c-.368-1.377.449-2.792 1.825-3.16l9.047-2.425c1.377-.368 2.791.448 3.16 1.825l1.473 5.499c.37 1.376-.448 2.791-1.824 3.16z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#27D6FF",
    fillRule: "evenodd",
    d: "M24.99 20.023c.815-3.04-1.424-6.281-5-7.24-3.576-.957-7.135.73-7.95 3.77-.814 3.04 1.424 6.281 5 7.24.46.123.92.2 1.374.239l2.255 1.913c.329.28.834.044.832-.387l-.01-1.918c1.712-.624 3.04-1.906 3.5-3.617z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#320B42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.211,
    d: "M24.99 20.023c.815-3.04-1.424-6.281-5-7.24-3.576-.957-7.135.73-7.95 3.77-.814 3.04 1.424 6.281 5 7.24.46.123.92.2 1.374.239l2.255 1.913c.329.28.834.044.832-.387l-.01-1.918c1.712-.624 3.04-1.906 3.5-3.617z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCB608",
    fillRule: "evenodd",
    d: "M6.144 17.785l2.638 1.762 2.946-1.175-.86 3.053 2.027 2.439-3.169.125-1.693 2.682-1.099-2.975-3.073-.782 2.49-1.964-.207-3.165z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#320B42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.211,
    d: "M6.144 17.785l2.638 1.762 2.946-1.175-.86 3.053 2.027 2.439-3.169.125-1.693 2.682-1.099-2.975-3.073-.782 2.49-1.964-.207-3.165z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M14.02 6.723c.48 1.788-.581 3.626-2.369 4.105-1.788.479-3.625-.582-4.105-2.37l6.475-1.735z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#320B42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.211,
    d: "M14.02 6.723c.48 1.788-.581 3.626-2.369 4.105-1.788.479-3.625-.582-4.105-2.37l6.475-1.735z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#320B42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1,
    d: "M17.297 16.389c.277-1.036 1.451-1.592 2.463-1.057.56.295.912.908.889 1.539-.033.894-.693 1.54-1.475 1.648-.429.059-.782.367-.894.786l-.133.496"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#320B42",
    fillRule: "evenodd",
    d: "M18.425 21.636c-.09.338-.44.54-.778.449-.339-.091-.54-.44-.45-.778.092-.339.44-.54.779-.45.339.092.54.44.45.779z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardWinning);
export default __webpack_public_path__ + "static/media/AwardWinning.48ff922e5463c9af7299481bd99b9695.svg";
export { ForwardRef as ReactComponent };